import { useState } from 'react';
import tabSelect from '../../../utils/tabSelect';
import '../../detailsTabs/detailsTabs.css';
import Overview from '../../detailsTabs/overView/Overview';
import Itinerary from '../../detailsTabs/itinerary/Itinerary';
import Included from '../../detailsTabs/included/Included';
import FAQ from '../../detailsTabs/FAQ/FAQ';
import { Rooms } from '../../detailsTabs/rooms/Rooms';
import TermsDis from '../../detailsTabs/termsDis/TermsDis';
import Comments from '../../detailsTabs/comments/comments';
import Safety from '../../detailsTabs/safety/safety';
import Pickup from '../../detailsTabs/pickup/Pickup';
import Bookings from '../../detailsTabs/Bookings/Bookings';
import Price from '../../detailsTabs/Price/Price';
import TripTypes from '../tripTypes/TripTypes';
import TripTags from '../tripTags/TripTags';

export default function SupportTripDetialsTabs({ tripDetailsData, isExpanded, setIsExpanded, typeSel, refresh }) {
    const [selectedTab, setSelectedTab] = useState('Overview');
    const meetupOrPickupTab =
        tripDetailsData.group === 'vehicle' || tripDetailsData.datesType === 'custom'
            ? { heading: 'Meetup', value: 'Meetup' }
            : { heading: 'Pickup', value: 'Pickup' };
    const tabs = [
        { heading: 'Rooms', value: 'Rooms', for: 'ayur' },
        { heading: 'Overview', value: 'Overview' },
        meetupOrPickupTab,
        { heading: 'Itinerary', value: 'Itinerary', for: 'trip' },
        { heading: 'Inc/Exc', value: 'Including' },
        { heading: 'Safety', value: 'Safety' },
        { heading: 'Carry', value: 'Carry' },
        { heading: 'FAQ', value: 'FAQ' },
        { heading: 'Terms', value: 'Terms' },
        { heading: 'Price', value: 'Price' },
        { heading: 'Tags', value: 'Tags' },
        { heading: 'Bookings', value: 'Bookings' },
        { heading: 'Comments', value: 'Comments' },
        { heading: 'Types', value: 'Types' }
    ];
    const whichType =
        window.location.pathname.split('/')[1] === 'support'
            ? window.location.pathname.split('/')[2]
            : window.location.pathname.split('/')[1];

    const whichSection = window.location.pathname.split('/')[1];
    return (
        <div>
            <div
                className={
                    whichSection === 'org' || whichSection === 'support' ? 'orgTripDetailsTabs' : 'tripDetailsTabs'
                }
                style={{ position: 'sticky' }}
            >
                {tabs.map(function (tab, tabIndex) {
                    return (
                        <button
                            key={tabIndex}
                            className={`${
                                selectedTab === tab.value ? 'tripDetailsTabButtonHi' : 'tripDetailsTabButton'
                            } ${(whichType === 'trip' || whichType === 'guid') && tab.for === 'ayur' && 'tripHide'}
              ${whichType === 'camp' && tab.for === 'trip' && 'tripHide'}
              ${whichSection === 'support' && tab.for === 'ayur' && 'tripHide'}
                ${tripDetailsData.datesType === 'fixed' && tab.heading === 'Bookings' && 'tripHide'}`}
                            onClick={() => {
                                if (isExpanded) {
                                    setIsExpanded(false);
                                }
                                tabSelect(tab.value, setSelectedTab);
                            }}
                        >
                            {tab.heading}
                        </button>
                    );
                })}
            </div>
            <div className='tripDetailsInfoDiv'>
                {selectedTab === 'Overview' && <Overview data={tripDetailsData?.overview} />}
                {selectedTab === 'Rooms' && <Rooms data={tripDetailsData?.overview} />}
                {selectedTab === 'Itinerary' && <Itinerary data={tripDetailsData?.itinerary} />}
                {selectedTab === 'Including' && (
                    <Included dataInc={tripDetailsData?.included} dataExc={tripDetailsData?.excluded} />
                )}
                {selectedTab === 'FAQ' && <FAQ data={tripDetailsData?.FAQ} />}
                {selectedTab === 'Terms' && <TermsDis data={tripDetailsData?.terms} />}
                {selectedTab === 'Safety' && <Safety type='safety' data={tripDetailsData?.safety} />}
                {selectedTab === 'Carry' && <Safety type='carry' data={tripDetailsData?.carry} />}
                {selectedTab === 'Pickup' && <Pickup type='pickup' data={tripDetailsData?.price[0].pickupLocation} />}
                {selectedTab === 'Meetup' && <Pickup type='pickup' data={tripDetailsData?.price[0].meetupPoint} />}
                {selectedTab === 'Price' && (
                    <Price
                        data={tripDetailsData?.price}
                        dateType={tripDetailsData.datesType}
                        group={tripDetailsData.group}
                    />
                )}
                {selectedTab === 'Tags' && <TripTags tripDetailsData={tripDetailsData} />}
                {selectedTab === 'Bookings' && <Bookings packData={tripDetailsData} refresh={refresh} />}
                {selectedTab === 'Comments' && <Comments data={tripDetailsData?.supComments} />}
                {selectedTab === 'Types' && <TripTypes tripDetailsData={tripDetailsData} />}
            </div>
        </div>
    );
}
